import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { GERMAN } from "../actions/language";
import { LanguageContext } from "../context/LanguageContext";
import PageHero from "./common/PageHero";
import CtaBand from "./common/CtaBand";

const Leistungen = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    const services = [
        {
            index: '01',
            title: de ? 'Büroservice' : 'Serviço de Escritório',
            subtitle: de ? 'Ihre Entlastung im Büroalltag' : 'O seu alívio no dia a dia',
            text: de
                ? 'Wir übernehmen die komplette Vorbereitung Ihrer Unterlagen für den Steuerberater – einschließlich Sortierung und digitaler Aufbereitung aller relevanten Dokumente. Dazu kommt die Lohnbuchhaltung: von der Zeiterfassung bis zur Gehaltsabrechnung.'
                : 'Tratamos da preparação completa dos seus documentos para o consultor fiscal – incluindo a triagem e a preparação digital de todos os documentos relevantes. A isto acresce a contabilidade salarial: do registo de horas à folha de vencimento.',
            items: de
                ? ['Unterlagen für den Steuerberater', 'Lohnbuchhaltung & Gehaltsabrechnungen', 'Digitale Belegaufbereitung', 'Auswertungen & Reports']
                : ['Documentos para o consultor fiscal', 'Contabilidade & folhas de vencimento', 'Preparação digital de recibos', 'Análises & relatórios'],
            link: '/office-service'
        },
        {
            index: '02',
            title: de ? 'Hilfestellungen' : 'Apoio',
            subtitle: de ? 'Ihr Wegbegleiter für reibungslose Abläufe' : 'O seu companheiro para processos sem problemas',
            text: de
                ? 'Behördengänge, Unternehmensgründung oder Expansion nach Portugal bzw. Deutschland – mit Steuerberatern und Anwälten in beiden Ländern, Sprachunterstützung und Dokumentenübersetzung sorgen wir für einen reibungslosen Ablauf.'
                : 'Questões oficiais, criação de empresas ou expansão para Portugal ou Alemanha – com consultores fiscais e advogados em ambos os países, apoio linguístico e tradução de documentos, garantimos que tudo corre bem.',
            items: de
                ? ['Behördengänge & Formalitäten', 'Unternehmensgründung & Businesspläne', 'Internationale Expansion DE ↔ PT', 'Personalsuche & Anmeldung']
                : ['Autoridades & formalidades', 'Criação de empresas & planos de negócio', 'Expansão internacional DE ↔ PT', 'Recrutamento & registo'],
            link: '/assistance'
        },
        {
            index: '03',
            title: de ? 'Verwaltung' : 'Administração',
            subtitle: de ? 'Effiziente Organisation für Ihren Erfolg' : 'Organização eficiente para o seu sucesso',
            text: de
                ? 'Wir erstellen Rechnungen und Angebote nach Ihren Vorgaben, verwalten Ihren Briefverkehr und strukturieren Ihre administrativen Prozesse – damit Ihre Kommunikation professionell läuft.'
                : 'Preparamos faturas e orçamentos de acordo com as suas especificações, gerimos a sua correspondência e estruturamos os seus processos administrativos – para uma comunicação profissional.',
            items: de
                ? ['Rechnungen nach Vorgabe', 'Professionelle Angebote', 'Verwaltung des Briefverkehrs', 'Strukturierung von Abläufen']
                : ['Faturas por especificação', 'Orçamentos profissionais', 'Gestão da correspondência', 'Estruturação de processos'],
            link: '/administration'
        }
    ];

    return (
        <main>
            <PageHero
                eyebrow={de ? 'Leistungen' : 'Serviços'}
                title={de
                    ? <span>Ein Dienstleistungspaket, das <em>alles Wesentliche</em> abdeckt.</span>
                    : <span>Um pacote de serviços que cobre <em>todo o essencial</em>.</span>}
                lede={de
                    ? 'Mit einem erfahrenen Team und einem breiten Netzwerk aus Fachleuten in Deutschland und Portugal bieten wir Ihnen maximale Unterstützung bei Büroservice, Hilfestellungen und Verwaltung.'
                    : 'Com uma equipa experiente e uma vasta rede de profissionais na Alemanha e em Portugal, oferecemos-lhe o máximo apoio em serviços de escritório, assistência e administração.'}
            />

            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-services">
                        {services.map((service) => (
                            <div key={service.index} className="tm-service-card">
                                <span className="tm-service-card__index">
                                    {service.index} — {service.subtitle}
                                </span>
                                <h3 className="tm-service-card__title">{service.title}</h3>
                                <p className="tm-service-card__text">{service.text}</p>
                                <ul className="tm-service-card__list">
                                    {service.items.map((item, i) => <li key={i}>{item}</li>)}
                                </ul>
                                <Link to={service.link} className="tm-service-card__link">
                                    {de ? 'Zur Detailseite' : 'Ver detalhes'} <i className="fas fa-arrow-right"/>
                                </Link>
                            </div>
                        ))}
                    </div>

                    <div className="tm-callout" style={{ marginTop: "56px" }}>
                        <i className="fas fa-handshake"/>
                        <div>
                            <h3>{de ? 'Starke Partnerschaften' : 'Parcerias sólidas'}</h3>
                            <p>
                                {de
                                    ? 'Wir arbeiten eng mit einer international erfahrenen Steuerberaterin und einem Fachanwalt für Steuer- und Finanzrecht zusammen. So können Sie jederzeit auf kompetente Beratung und rechtliche Vertretung zurückgreifen – weit über den klassischen Büroservice hinaus.'
                                    : 'Trabalhamos em estreita colaboração com uma consultora fiscal com experiência internacional e um advogado especializado em direito fiscal e financeiro. Assim, pode sempre contar com aconselhamento competente e representação jurídica – muito além do serviço clássico de escritório.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <CtaBand/>
        </main>
    );
};

export default Leistungen;



// WEBPACK FOOTER //
// ./src/components/Leistungen.js